function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { cmsActions } from '../../reducers/cms.reducer';
import { posActions } from '../../reducers/pos.reducer';
import { connect, useSelector } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import articleTypeDict from '../../helpers/dictionary/articleTypeDict';
import useEnvArr from '../../helpers/hooks/useEnvArr';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import Table from '../common/table/Table.react';
import PageArticlesSlot from '../pages/page/PageArticlesSlot.modal';
import ArticlesAdd from './add/ArticlesAdd.modal';
var ArticlesTable = function ArticlesTable(_ref) {
  var _ref$app = _ref.app,
    app = _ref$app === void 0 ? null : _ref$app,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? null : _ref$page,
    articlesAction = _ref.articlesAction,
    addModalAction = _ref.addModalAction,
    pagesAction = _ref.pagesAction;
  var navigate = useNavigate();
  var cmsArticles = useSelector(function (s) {
    return s.cms.articles || {};
  });
  var cmsEnvironments = useSelector(function (s) {
    return s.settings.constants.environments || [];
  });
  var envArr = useEnvArr();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    articles = _useState2[0],
    setArticles = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    filter = _useState4[0],
    setFilter = _useState4[1];
  useEffect(function () {
    articlesAction({});
  }, []);
  useEffect(function () {
    if (page) setArticles(page.articles.map(function (x) {
      return cmsArticles[x.articleID._id] || {};
    }));else {
      setArticles(Object.values(cmsArticles).filter(function (x) {
        return !app || x.clientApp.includes(app);
      }));
    }
  }, [app, page, cmsArticles]);
  var getTitle = function getTitle() {
    if (page) return "".concat(page.title, " - ");else if (app) return "".concat(app, " - ");else return 'All ';
  };
  var getSlot = function getSlot(id) {
    var _page$articles;
    if (page !== null && page !== void 0 && (_page$articles = page.articles) !== null && _page$articles !== void 0 && _page$articles.find(function (x) {
      return x.articleID._id === id;
    })) return page.articles.find(function (x) {
      return x.articleID._id === id;
    }).slot;
    return 0;
  };
  var columns = {
    id: {
      title: '_id',
      visible: false
    },
    title: {
      title: 'Title',
      onClick: function onClick(_ref2) {
        var row = _ref2.row;
        if (app) navigate("/".concat(app, "/article/").concat(row._id));else navigate("/article/".concat(row._id));
      }
    },
    type: 'Type'
  };
  var data = articles.filter(function (x) {
    return !x.archived;
  }).map(function (x) {
    return {
      title: x.title,
      _id: x._id,
      type: articleTypeDict[x.type]
    };
  });
  if (page) {
    columns.slot = {
      title: 'Slot',
      size: 'contain',
      onClick: function onClick(_ref3) {
        var row = _ref3.row;
        addModalAction({
          component: /*#__PURE__*/React.createElement(PageArticlesSlot, {
            articleID: row._id,
            pageID: page._id
          })
        });
      }
    }, cmsEnvironments.forEach(function (x) {
      if (x.clientApp === app && envArr.includes(x.key)) columns[x.key] = {
        title: x.name,
        size: 'contain',
        onClick: function onClick(_ref4) {
          var row = _ref4.row,
            key = _ref4.key;
          pagesAction({
            formData: {
              pageID: page._id,
              articleID: row._id,
              env: key,
              isPublished: row[key] ? false : '1970-01-01'
            },
            method: 'put',
            route: 'article-publish'
          });
        }
      };
    });
    data.map(function (x) {
      x['slot'] = getSlot(x._id);
      var article = page.articles.find(function (y) {
        return y.articleID._id === x._id;
      });
      envArr.forEach(function (y) {
        var _article$published;
        return x[y] = article !== null && article !== void 0 && (_article$published = article.published) !== null && _article$published !== void 0 && _article$published.find(function (z) {
          return z.clientEnv === y;
        }) ? true : false;
      });
      return x;
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "".concat(getTitle(), " Articles"),
    button: {
      label: 'New Article',
      type: 'add',
      permission: 'edit-pos-articles',
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(ArticlesAdd, {
            app: app,
            pageID: page === null || page === void 0 ? void 0 : page._id,
            articleType: page === null || page === void 0 ? void 0 : page.articleType
          })
        });
      }
    },
    search: {
      query: filter,
      onChange: function onChange(e) {
        return setFilter(e.target.value);
      },
      label: 'Search Articles:',
      placeholder: 'Search...'
    }
  }), /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: data,
    filter: filter,
    filterColumns: ['title'],
    sort: {
      by: page ? 'slot' : 'title'
    }
  }))));
};
var mdtp = {
  articlesAction: cmsActions.articles,
  pagesAction: posActions.pages,
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(ArticlesTable);